import {
  Button,
  Modal,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  Avatar,
  IconButton,
} from '@mui/material';
import { Box } from '@mui/system';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { Exit } from 'Images';

interface IModal {
  isVisible: boolean;
  closeModal: () => void;
  deleteFile: () => void;
  fileName?: string;
  title?: string;
  subtitle?: string;
  approveButtonText?: string;
  declineButtonText?: string;
}

export const DeleteModal = ({
  closeModal,
  deleteFile,
  isVisible,
  approveButtonText,
  declineButtonText,
  fileName,
  title,
  subtitle,
}: IModal) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const dictionary = useDictionary(Dictionary, DICTIONARY.Requests);

  return (
    <Modal open={isVisible}>
      <Paper
        sx={{
          boxShadow: '0px 3px 21px 0px #2D70D926',
          padding: isDesktop ? '96px 100px 56px 100px' : '38px 16px 48px 16px',
          maxWidth: '550px',
          mb: '64px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          width: '80%',
        }}
      >
        <Typography>
          {title || dictionary.deleteFile.deleteModalFirstParagraph}
        </Typography>
        <fieldset>
          <legend style={{ display: 'block' }}>
            <Typography sx={{ mt: '20px', fontWeight: 'bold' }}>
              {subtitle || dictionary.deleteFile.deleteModalConfirmTitleGeneral}
            </Typography>
            {fileName && (
              <Typography maxWidth={'100%'} sx={{ lineBreak: 'anywhere' }}>
                {fileName}
              </Typography>
            )}
          </legend>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: '40px',
            }}
          >
            <Button variant={'outlined'} onClick={deleteFile}>
              {approveButtonText ||
                dictionary.deleteFile.deleteModalConfirmButton}
            </Button>
            <Button onClick={closeModal}>
              {declineButtonText ||
                dictionary.deleteFile.deleteModalCancelButton}
            </Button>
          </Box>
        </fieldset>

        <IconButton
          onClick={closeModal}
          sx={{
            position: 'absolute',
            top: isDesktop ? '25px' : '15px',
            right: isDesktop ? '25px' : '15px',
          }}
        >
          <Avatar
            src={Exit}
            sx={{
              width: '19px',
              height: '19px',
            }}
            alt={dictionary.deleteFile.deleteModalExitAlt}
          />
        </IconButton>
      </Paper>
    </Modal>
  );
};
